import React, { FunctionComponent, ReactElement } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText
} from '@mui/material';

import PanToolAltIcon from '@mui/icons-material/PanToolAlt';

import { User } from '../../../models/User';

type Props = {
  coach: User;
  onClick?: () => void;
  divider?: boolean;
};

export const ListItemCoach: FunctionComponent<Props> = ({divider, coach, onClick}) => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  return (<ListItem
    divider={!!divider}
    sx={!!onClick ? {
      cursor: 'pointer'
    } : {}}
    onClick={(e) => {
      e.preventDefault();
      if (!!onClick) onClick();
    }}
  >
    <ListItemAvatar>
      <Avatar src={coach.get_medium} alt={coach.full_name}></Avatar>
    </ListItemAvatar>
    <ListItemText primary={coach.full_name} secondary={(coach.coach_skills || []).map(skill => ((
      skill?.name_en && i18n.resolvedLanguage === 'en' ? skill?.name_en : (
        skill?.name_fr && i18n.resolvedLanguage === 'fr' ? skill?.name_fr : (
          skill?.name_de && i18n.resolvedLanguage === 'de' ? skill?.name_de : (
            skill.name
          )
        )
      )
    ) || skill.name)).sort().join(", ")}/>
    {!!onClick && <ListItemSecondaryAction>
      <IconButton edge="end" aria-label="settings" onClick={(e) => {
        e.preventDefault();
        if (!!onClick) onClick();
      }}>
        <PanToolAltIcon />
      </IconButton>
    </ListItemSecondaryAction>}
  </ListItem>);
}